import { t } from "../i18n.ts";
import type { UnitPosition } from "./types.ts";

/** Где изделие на маршруте одной строкой (МР-20): карантин, шаг, «зависло», пройдено. */
export function PositionText({ position: p }: { position: UnitPosition }) {
  if (p.quarantined) return <span className="pos pos-alert">{t("pos.quarantine", { reason: p.quarantineReason ?? "" })}</span>;
  return (
    <span className="pos">
      {p.routeDone ? (
        <span className="pos-done">{t("pos.done")}</span>
      ) : p.step ? (
        <span className={p.stuck ? "pos-alert" : undefined}>
          {t("pos.step", { step: p.step })}
          {p.stuck ? ` · ${t("pos.stuck", { hours: p.idleHours })}` : ""}
        </span>
      ) : null}
      {p.packedWithOpenRoute ? <span className="pos-alert">{` · ${t("pos.openRoute")}`}</span> : null}
    </span>
  );
}
